var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHelpSquarecomponent = function SvgHelpSquarecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h14zm-7 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-8a3 3 0 0 0-3 3 1 1 0 0 0 2 0 1 1 0 1 1 2 0c0 .39-.249.758-.554.958l-.213.123-.196.1c-.674.345-1.037.876-1.037 1.569V13a1 1 0 1 0 2 0v-.25c0-.039.017-.075.051-.106l.066-.053.15-.08.209-.118A3 3 0 0 0 12 7z"
  })));
};
export default SvgHelpSquarecomponent;